import { render, staticRenderFns } from "./OrderDocuments.vue?vue&type=template&id=1477036f&scoped=true&"
import script from "./OrderDocuments.vue?vue&type=script&lang=js&"
export * from "./OrderDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OrderDocuments.vue?vue&type=style&index=0&id=1477036f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477036f",
  null
  
)

export default component.exports